import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Image as ImageIcon, X, ChevronRight } from 'lucide-react';

const ProfileImageCTA: React.FC = () => {
  const { currentUser } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [isDismissed, setIsDismissed] = useState(false);

  // If not logged in, or already has a photoURL, or is on the profile page, don't show
  if (!currentUser || currentUser.photoURL || location.pathname === '/profile' || isDismissed) {
    return null;
  }

  return (
    <div className="fixed bottom-6 right-6 z-50 animate-bounce" style={{ animationDuration: '3s' }}>
      <div className="bg-gradient-to-r from-indigo-600 to-purple-600 p-[2px] rounded-2xl shadow-2xl hover:scale-105 transition-transform duration-300">
        <div className="bg-white/10 backdrop-blur-md text-white p-4 rounded-[14px] flex items-center gap-4 max-w-sm cursor-pointer border border-white/20" onClick={() => navigate('/profile')}>
          <div className="bg-white/20 p-3 rounded-xl shrink-0">
            <ImageIcon className="w-6 h-6 text-white" />
          </div>
          <div className="flex-1">
            <h4 className="font-extrabold text-lg flex items-center gap-1">
              Stand out! ✨
            </h4>
            <p className="text-sm font-medium text-indigo-50 mt-0.5">
              Create your unique profile avatar to get noticed.
            </p>
          </div>
          <div className="flex flex-col items-end justify-between h-full space-y-3">
            <button 
              onClick={(e) => { e.stopPropagation(); setIsDismissed(true); }}
              className="p-1 bg-white/10 hover:bg-white/30 rounded-full transition-colors backdrop-blur-sm"
              aria-label="Close"
            >
              <X className="w-4 h-4 text-white" />
            </button>
            <ChevronRight className="w-5 h-5 text-white/70" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileImageCTA;
